import { NgModule }                        from '@angular/core';
import { CommonModule }                    from '@angular/common';
import { FormsModule, ReactiveFormsModule }                     from '@angular/forms';
import { RouterModule }                    from '@angular/router';
import { BrowserModule }                   from "@angular/platform-browser";
import { PerfectScrollbarModule }          from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG }        from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { TranslateModule }                 from '@ngx-translate/core';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

@NgModule({
  imports:      [
      CommonModule,
      PerfectScrollbarModule,
      TranslateModule
  ],
    providers:    [{
        provide: PERFECT_SCROLLBAR_CONFIG,
        useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }],
  declarations: [
  ],
  exports:      [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      BrowserModule,
      PerfectScrollbarModule,
      TranslateModule,
      RouterModule
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/shared/shared.module.ts